import styled from "styled-components";

/* emoji-picker-react in the editor's dark theme: the search in the standard field (components/Form/Input), the
   categories as tabs with the current one underlined in green, bigger emojis */
export const PickerArea = styled.div`
  /* The search first, then the category tabs (with the current one's green line), then the emojis */
  .emoji-picker-react {
    font-family: Inter, sans-serif;
    background: transparent;
    border: 0;
    border-radius: 0;

    > div:not([class]) {
      order: -1;
    }

    .active-category-indicator-wrapper {
      padding: 0 20px;

      .active-category-indicator {
        height: 2px;
        background: var(--color-brand-plus);
      }
    }
  }

  .emoji-picker-react input.emoji-search {
    width: calc(100% - 40px);
    height: auto;
    margin: 0 20px;
    padding: 0.875rem 1rem;
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1rem;
    color: var(--color-neutral-white);
    background: transparent;
    border: 2px solid var(--color-neutral-light);
    border-radius: 10px;

    &::placeholder {
      color: var(--color-neutral-150);
    }

    &:focus {
      border-color: var(--color-brand-pink);
      box-shadow: none;
    }
  }

  .emoji-picker-react .emoji-categories {
    padding: 12px 20px 0;
    border-bottom: 1px solid var(--color-neutral-base);

    button {
      height: 36px;
      filter: invert(1);
      opacity: 0.45;
      border-bottom: 2px solid transparent;
    }

    button.active {
      opacity: 1;
    }
  }

  .emoji-picker-react .emoji-scroll-wrapper {
    padding: 0 12px;
  }

  .emoji-picker-react .emoji-group:before {
    font-family: Inter, sans-serif;
    font-size: 0.6875rem;
    font-weight: 700;
    color: var(--color-neutral-150);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    background: var(--color-neutral-dark);
  }

  .emoji-picker-react .content-wrapper-epr:before {
    color: var(--color-neutral-150);
  }

  .emoji-picker-react .emoji button {
    font-size: 26px;
    border-radius: 10px;

    &:hover {
      background: var(--color-neutral-base);
    }
  }

  .emoji-picker-react ul.skin-tones-list {
    top: 30px;
    right: 30px;
  }
`;
